/*
 * Cookie getters and setters.
 */
function createCookie(cookieName,cookieValue,hoursToExpire){
    var date = new Date();
    date.setTime(date.getTime()+(hoursToExpire*60*60*1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + '; path=/';
}
function accessCookie(cookieName){
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for(var i=0; i<allCookieArray.length; i++){
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name)==0)
        return temp.substring(name.length,temp.length);
    }
    return false;
}
function checkCookie(txt){
    if( accessCookie(txt) )
      return true;
    else
      return false;
}